import { Routes, Route } from 'react-router-dom';
import Home from '../../pages/home/Home';
import Internal from '../../pages/internal/Internal';

const App = () => {
    return (
        <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/internal" element={<Internal />} />
        </Routes>
    );
};

export default App;
